module.exports = __webpack_public_path__ + "img/coolwallet.3cd3d656.svg";